"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LATEST_CATALOGUES = void 0;
const LATEST_CATALOGUES = exports.LATEST_CATALOGUES = 'latest-catalogues';
